import React from "react";
import './on_boarding.scss';
import {OnBoardingRoute} from "../../routes/MainRoute";

function OnBoarding() {
    return <OnBoardingRoute/>
}

export default OnBoarding;
